import { useCallback, useEffect, useState } from "react";
import { IGetPurchaseResponse, getAll } from "services/purchase";
import { useAppSelector } from "store/hooks";
import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper
} from "@mui/material";
import dayjs from "dayjs";
import { formatter } from "services/misc";
import styles from "./../dashboard.module.scss";

const Purchases = (props: any) => {
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState<IGetPurchaseResponse[]>([]);
  const { jwt } = useAppSelector((state) => state.app);
  
  const handleGetAllPurchases = useCallback(async () => {
    try {
      const response = await getAll(jwt!);
      setList(response);
      setLoading(false);
    } catch(err) {
      console.log(err);
    }
  }, [jwt]);

  useEffect(() => {
    handleGetAllPurchases()
  },[handleGetAllPurchases]);

  return (
    <>
      {loading ? (
        <>
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </>
      ) : (
        <Paper elevation={0} className={styles["table-wrapper"]}>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Trees Planted</TableCell>
                  <TableCell>Years Offset</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell>Datetime</TableCell>
                  <TableCell>Payment Status</TableCell>
                  <TableCell>Planted</TableCell>
                  <TableCell>Certificate</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.length > 0 ? (
                  <>
                    {list.map((item, i) => {
                      const date = dayjs(item.createdAt)
                      return (
                        <TableRow
                          hover={true}
                          key={i}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                            "&:hover": { cursor: "pointer" },
                          }}
                        >
                          <TableCell>{item.quantity}</TableCell>
                          <TableCell>{item.years}</TableCell>
                          <TableCell>{formatter.format(item.amount_total)}</TableCell>
                          <TableCell>{date.format(
                            "MMMM D, YYYY h:mm A"
                          )}</TableCell>
                          <TableCell>{item.payment_status}</TableCell>
                          <TableCell>Not yet</TableCell>
                          <TableCell>Not yet</TableCell>
                        </TableRow>
                      )
                    })}
                  </>
                ) : (
                  <TableRow>
                    <TableCell
                      className="text-center"
                      sx={{ border: 0 }}
                      colSpan={2}
                    >
                      <Typography my={2} variant="body2">
                        Nothing yet
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      )}
    </>
  )
};

export default Purchases;
